import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";

import "../css/style.css";
import i18next from "i18next";
import { cardMode, landingDomain } from "../_constants";
import { showGlobalSnackbar } from "../_services/snackbarService";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default function UserInfoDialog(props) {
  const [data, setData] = React.useState({});
  const [ch1, setCh1] = React.useState(false);
  const [ch2, setCh2] = React.useState(false);

  const { handleClose, flds, optionalFields, showContactsSetting, dialogOpen } =
    props;

  // Раньше начальные значения засеивались вызовами setInfo прямо в рендере
  // (в showFields и в этом же месте) — setState во время рендера, лишние проходы,
  // а при повторном открытии диалога state не сбрасывался и показывались данные
  // от прошлого раза. Теперь и сброс, и засев — в эффектах.
  React.useEffect(() => {
    if (!dialogOpen) return;
    setData({});
    setCh1(false);
    setCh2(false);
  }, [dialogOpen]);

  // Значения могут прийти после открытия (их грузят асинхронно), поэтому эффект
  // следит за props.values и доливает недостающее, не затирая уже введённое руками.
  React.useEffect(() => {
    if (!dialogOpen) return;
    setData((prev) => {
      const next = { ...prev };
      const values = props.values || {};
      Object.keys(values).forEach((key) => {
        if (!next[key] && values[key]) next[key] = values[key];
      });
      // Object.hasOwn — ES2022, его нет в Android WebView до Chrome 93.
      if (
        showContactsSetting === "show" &&
        !Object.prototype.hasOwnProperty.call(next, "show_contacts")
      ) {
        next.show_contacts = [];
      }
      return next;
    });
  }, [dialogOpen, props.values, showContactsSetting]);

  function openPdf() {
    const url = `https://${landingDomain}/consent-to-processing-personal-data/`;

    //window.open(process.env.REACT_APP_USER_AGR, "_blank");
    window.open(url, "_blank");
  }

  function openUrl1() {
    const url = props.urlPdNc;

    //window.open(process.env.REACT_APP_USER_AGR, "_blank");
    window.open(url, "_blank");
  }

  function openUrl2() {
    const url = props.urlPdOrg;

    //window.open(process.env.REACT_APP_USER_AGR, "_blank");
    window.open(url, "_blank");
  }

  // Google Play требует путь к удалению аккаунта изнутри приложения. Удаление —
  // по запросу со страницы сайта, поэтому здесь только ссылка на неё; обёртка
  // выпускает naviconf.com во внешний браузер.
  function openDeleteAccount(e) {
    e.preventDefault();
    window.open(`https://${landingDomain}/docs/delete-account/`);
  }

  function cancelData() {
    handleClose(null);
  }

  function saveData() {
    if (!props.fullMode && (!ch1 || !ch2)) {
      showGlobalSnackbar(i18next.t("pers_data_agr"), "warning");
      return;
    }

    if (data && flds) {
      let isOk = true;

      for (let i = 0; i < flds.length; i++) {
        let itemId = flds[i];
        if (typeof flds[i] === "object") {
          //custom field
          itemId = Object.keys(flds[i])[0];
        }
        if (!data[itemId]) {
          isOk = false;
          break;
        }
      }

      if (isOk) {
        handleClose({ ...data });
      } else {
        showGlobalSnackbar(i18next.t("too_short_fields"), "warning");
      }
    }
  }

  function setInfo(name, val) {
    setData((prev) => ({ ...prev, [name]: val }));
  }

  function showFields(flds, required) {
    return (
      flds &&
      flds.map(function (item, index) {
        let itemId = item;
        let itemLabel = null;
        if (typeof item === "object") {
          //custom field
          itemId = Object.keys(item)[0];
          const itemInfo = item[itemId];
          itemLabel = itemInfo.title;
          if (itemInfo.type !== "text") {
            const itemOptions = itemInfo.items;
            if (itemInfo.type === "radio") {
              return (
                itemOptions && (
                  <div key={itemId}>
                    <FormLabel>{itemLabel}</FormLabel>
                    <RadioGroup
                      required={required}
                      key={"anketa-radio-" + itemId}
                    >
                      {itemOptions.map((item) => (
                        <FormControlLabel
                          control={<Radio />}
                          checked={
                            data &&
                            data[itemId] &&
                            data[itemId].indexOf(item.id) !== -1
                          }
                          label={item.label}
                          key={"anketa-option-" + item.id}
                          value={item.id}
                          onChange={(e) =>
                            setInfo(itemId, e.target.checked ? [item.id] : [])
                          }
                        />
                      ))}
                    </RadioGroup>
                  </div>
                )
              );
            }
            if (itemInfo.type === "checkbox") {
              return (
                itemOptions && (
                  <div key={itemId}>
                    <FormLabel>{itemLabel}</FormLabel>
                    <FormGroup
                      required={required}
                      key={"anketa-checkbox-" + itemId}
                    >
                      {itemOptions.map((item) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                data &&
                                data[itemId] &&
                                data[itemId].indexOf(item.id) !== -1
                              }
                              onChange={function (e) {
                                let value = data ? data[itemId] || [] : [];
                                if (e.target.checked) {
                                  value.push(item.id);
                                  value = [...new Set(value)];
                                } else {
                                  value = value.filter(
                                    (valueItem) => valueItem != item.id
                                  );
                                }
                                setInfo(itemId, value);
                              }}
                            />
                          }
                          label={item.label}
                          key={"anketa-option-" + item.id}
                          value={item.id}
                        />
                      ))}
                    </FormGroup>
                  </div>
                )
              );
            }
          }
        }
        return (
          <TextField
            autoFocus={index === 0}
            margin="dense"
            id={itemId}
            key={itemId}
            label={itemLabel}
            fullWidth
            variant="standard"
            value={data && data[itemId] ? data[itemId] : ""}
            required={required}
            onChange={(e) => setInfo(itemId, e.target.value)}
          />
        );
      })
    );
  }

  return (
    <Dialog open={dialogOpen} fullScreen={!!props.fullScreen}>
      <DialogTitle>
        {i18next.t(props.fullMode ? "edit_anket" : "fill_anket")}
      </DialogTitle>
      <DialogContent style={{ minWidth: 280, maxWidth: 580 }}>
        {showFields(flds, true)}
        {showFields(optionalFields, false)}
        {showContactsSetting === "show"
          ? showFields(
              [
                {
                  show_contacts: {
                    title: i18next.t("participation_settings"),
                    type: "checkbox",
                    items: [
                      { id: -1, label: i18next.t("show_contacts_setting") },
                    ],
                  },
                },
              ],
              false
            )
          : ""}
        {!props.fullMode && (
          <div
            style={{
              marginTop: 10,
              fontSize: 16,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Checkbox checked={ch1} onChange={() => setCh1(!ch1)} />
            </div>
            <div
              style={{ marginTop: 10 }}
              className="link-wrapper"
              dangerouslySetInnerHTML={{ __html: props.urlPdOrg }}
            ></div>
          </div>
        )}
        {!props.fullMode && (
          <div
            style={{
              marginTop: 5,
              fontSize: 16,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Checkbox checked={ch2} onChange={() => setCh2(!ch2)} />
            <div
              style={{ marginTop: 10 }}
              className="link-wrapper"
              dangerouslySetInnerHTML={{ __html: props.urlPdNc }}
            ></div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={saveData}>
          {i18next.t(props.fullMode ? "btn_save" : "registry")}
        </Button>
        <Button onClick={cancelData}>{i18next.t("btn_cancel")}</Button>
      </DialogActions>
      {/* Под кнопками, а не рядом: разрушительное по смыслу действие возле
          «Сохранить» легко задеть. Без fullMode это регистрация — аккаунта ещё нет. */}
      {cardMode && props.fullMode && (
        <div className="card-delete-account">
          <a
            href={`https://${landingDomain}/docs/delete-account/`}
            onClick={openDeleteAccount}
          >
            {i18next.t("delete_account")}
          </a>
        </div>
      )}
    </Dialog>
  );
}

/*
            <span
              style={{
                color: "#0f2d51",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={openUrl2}
            >
              {i18next.t("agr_pd_2")}
            </span>
            */
